export enum Method {
  TRANSIENT_FLOW_FIXED_RADIUS = "TRANSIENT_FLOW_FIXED_RADIUS",
  WYSSLING = "WYSSLING",
  UNIFORM_FLOW = "UNIFORM_FLOW",
  KRIJGSMAN_LOBO_FERREIRA = "KRIJGSMAN_LOBO_FERREIRA",
  JACOB_BEAR = "JACOB_BEAR",
  DRASTIC_EPPNA = "DRASTIC_EPPNA",
  GOD_AVI = "GOD_AVI",
  TIMFLOW_STEADY = "TIMFLOW_STEADY",
}